import { apiClient } from './api'

export interface ContactFormData {
  name: string
  email: string
  phone?: string
  subject: string
  category: 'general' | 'technical' | 'billing' | 'feature'
  message: string
}

export interface ContactSubmissionResponse {
  id: string
  name: string
  email: string
  phone?: string
  subject: string
  category: string
  message: string
  status: string
  created_at: string
  updated_at?: string
}

export const contactService = {
  submitContactForm: async (data: ContactFormData & { turnstileToken?: string }): Promise<ContactSubmissionResponse> => {
    const { turnstileToken, ...formData } = data
    const { data: response } = await apiClient.post<ContactSubmissionResponse>('/contact/submit', {
      ...formData,
      turnstile_token: turnstileToken,
    })
    return response
  }
}
